// import request from '@/util/server.js'
import {uploadURL} from '@/utils/server.js'

export const upload = uploadURL + '/file/upload'
